// extracted by mini-css-extract-plugin
export default {"Breadcumb":"Breadcumb_Breadcumb__3cWLX","title":"Breadcumb_title__+rBqf"};